import NotificationsModel from '../models/NotificationsModel';

export default class NotificationsCollection extends Backbone.Collection {
  constructor(options) {
    super(options);

    this.model = NotificationsModel;
  }

  url() {
    return (
      appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
      + appConstants.ApiPaths.API_VERSION_PATH
      + appConstants.EndPoints.NOTIFICATIONS_PATH
    );
  }

  parse(data) {
    return data.notifications ? data.notifications : data;
  }

  dispatchCallback(payload) {
    const { actionType } = payload;
    const { ActionTypes } = appConstants;

    switch (actionType) {
      case ActionTypes.GET_NOTIFICATIONS:
        Utils.setMakeshiftTokenHeader();
        NotificationsStore.fetch({
          url:
            appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
            + appConstants.ApiPaths.API_VERSION_PATH
            + appConstants.EndPoints.NOTIFICATIONS_PATH,
          type: 'GET',
          data: payload.postData,
          success: NotificationsStore.onNotificationsHandler,
          fail: NotificationsStore.onNotificationsError,
        });
        break;
      case ActionTypes.MARK_NOTIFICATION_AS_READ:
        Utils.setMakeshiftTokenHeader();
        const notificationId = payload.postData.notification_id;

        let updateNotificationUrl = appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
          + appConstants.ApiPaths.API_VERSION_PATH
          + appConstants.EndPoints.NOTIFICATIONS_MARK_AS_READ;
        updateNotificationUrl = updateNotificationUrl.replace('%d', notificationId);

        $.ajax({
          method: 'PUT',
          dataType: 'json',
          contentType: 'application/json',
          url: updateNotificationUrl,
          success: NotificationsStore.onNotificationMarkedAsReadHandler,
          error: NotificationsStore.onNotificationsError,
        });
        break;
      case ActionTypes.MARK_ALL_NOTIFICATIONS_AS_READ:
        Utils.setMakeshiftTokenHeader();

        const updateAllNotificationsUrl = appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
          + appConstants.ApiPaths.API_VERSION_PATH
          + appConstants.EndPoints.NOTIFICATIONS_MARK_ALL_AS_READ;

        $.ajax({
          method: 'PUT',
          dataType: 'json',
          contentType: 'application/json',
          url: updateAllNotificationsUrl,
          success: NotificationsStore.onNotificationMarkedAsReadHandler,
          error: NotificationsStore.onNotificationsError,
        });

        break;

      default:
        break;
    }
  }
}
